import React, { useState } from 'react';
import { Section, Container } from '../../common/UI';
import Timeline from './Timeline';
import ExperienceCard from './ExperienceCard';
import ExperienceStats from './ExperienceStats';
import { useExperience } from '../../../context/ExperienceContext';

const Experience = () => {
  const { experiences, loading, error, yearsOfExperience } = useExperience();
  const [viewMode, setViewMode] = useState('timeline'); // 'timeline' or 'cards'

  if (error) {
    return (
      <Section id="experience" background="alt" padding="default">
        <Container>
          <div className="text-center py-16">
            <div className="text-red-500 mb-4">⚠️</div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Oops! Something went wrong
            </h3>
            <p className="text-gray-600 dark:text-gray-300">{error}</p>
          </div>
        </Container>
      </Section>
    );
  }

  return (
    <Section id="experience" background="alt" padding="default">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Professional Experience
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-6">
            My journey as a developer - from co-founding a startup to specializing in backend development
          </p>
          <div className="flex items-center justify-center space-x-4 text-sm">
            <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 px-4 py-2 rounded-full font-semibold">
              {yearsOfExperience.displayText} Years Experience
            </span>
            <span className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 px-4 py-2 rounded-full font-semibold">
              {experiences.length} Positions
            </span>
          </div>
        </div>

        {/* Experience Stats */}
        <ExperienceStats experiences={experiences} totalExperience={yearsOfExperience} />

        {/* View Toggle */}
        <div className="flex justify-center mb-12">
          <div className="bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
            <button
              onClick={() => setViewMode('timeline')}
              className={`px-6 py-2 rounded-md font-medium transition-all ${
                viewMode === 'timeline'
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
              }`}
            >
              Timeline View
            </button>
            <button
              onClick={() => setViewMode('cards')}
              className={`px-6 py-2 rounded-md font-medium transition-all ${
                viewMode === 'cards'
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
              }`}
            >
              Cards View
            </button>
          </div>
        </div>

        {/* Experience Display */}
        {loading ? (
          <div className="text-center py-16">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            <p className="text-gray-600 dark:text-gray-300 mt-4">Loading experience...</p>
          </div>
        ) : viewMode === 'timeline' ? (
          <Timeline experiences={experiences} />
        ) : (
          <div className="grid gap-8">
            {experiences.map((experience) => (
              <ExperienceCard key={experience.id} experience={experience} />
            ))}
          </div>
        )}
      </Container>
    </Section>
  );
};

export default Experience;